import React from 'react';
import './Unautherized.scss';

const Unautherized = () => {
  return (
    <div>
      You are not allowed to see this page, Please contact administrator
    </div>
  );
};

export default Unautherized;
